import React, { useCallback } from 'react';
import { DialogContent, DialogTitle } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useCallbackRef } from '../../hooks';
import Dialog from '../../dialogs/components/Dialog';
import { useDialogControl } from '../../dialogs/components/DialogControlContext';
import LocationForm from './LocationForm';
import { getLocationPath } from '../../nav/paths';
import DialogFormActions from '../../dialogs/components/DialogFormActions';

const LocationDialog = () => {
    const ref = useCallbackRef();
    const history = useHistory();
    const { onClose } = useDialogControl();

    const handleDone = useCallback(
        ({ data }) => {
            history.push(getLocationPath(data.id));
            onClose();
        },
        [history, onClose]
    );

    return (
        <Dialog fullWidth maxWidth="md">
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Neuer Standort</DialogTitle>

            <DialogContent>
                <LocationForm onDone={handleDone} submitRef={ref} />
            </DialogContent>

            <DialogFormActions ref={ref} />
        </Dialog>
    );
};

LocationDialog.propTypes = {};

LocationDialog.defaultProps = {};

export default LocationDialog;
